import { useDroppable } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'

import Typography from '../../atoms/typography'
import SortableItem from './sortable-item'
import { KanbanColumnWithData, KanbanItemRequiredFields } from './types'

const KanbanColumn = <T extends KanbanItemRequiredFields>({
  id,
  title,
  subtitle,
  icon: Icon,
  data,
  gap,
  disabled,
  card
}: KanbanColumnWithData<T> & { gap?: number; disabled?: boolean }) => {
  const { setNodeRef } = useDroppable({ id })

  return (
    <div className={cn('bg-primary-light p-5 rounded-lg ', disabled && 'brightness-90')}>
      <div className={'flex justify-between items-start gap-2'}>
        <div className="flex flex-row gap-2 items-start min-w-0">
          <Icon width="24px" height="24px" color={tailwindColors.grey.DEFAULT} />
          <div className="flex flex-col gap-1 min-w-0">
            <Typography variant="text" color={tailwindColors.grey.DEFAULT}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="label-semibold" className="text-red">
                {subtitle}
              </Typography>
            )}
          </div>
        </div>
        <div
          className={
            'w-[30px] h-[30px] bg-secondary-light-hover rounded-full flex justify-center items-center'
          }
        >
          <Typography variant="label-semibold" className="text-secondary">
            {data?.length}
          </Typography>
        </div>
      </div>
      <div className={' h-[80vh] min-w-72 overflow-auto'}>
        <SortableContext
          id={id?.toString()}
          items={data}
          strategy={verticalListSortingStrategy}
          disabled={disabled}
        >
          <div
            ref={setNodeRef}
            style={{ gap: `${gap}px` }}
            className={' h-full flex-1 pt-4 flex flex-col gap-[14px]'}
          >
            {data.map((item) => (
              <SortableItem key={item.id} {...item} card={card} />
            ))}
          </div>
        </SortableContext>
      </div>
    </div>
  )
}

export default KanbanColumn
